export const setupAttendeeUserItemState = (userId, attendeeEmail, members) => {
    const options = members
        ? members.map(i => ({
            ...i,
            label: i.id,
            value: i.id,
        })) : []
    const member = members.find(i => (i.userId === userId))
    const desiredState = {
        attendeeEmail,
        userId,
        options,
        selectedMember: member
            ? [{ ...member, label: member.id, value: member.id }]
            : [],
    }
    return desiredState
}


// WEBPACK FOOTER //
// ./src/components/connected_apps/attendee_user_matching_item_utils.js